module.exports = __webpack_public_path__ + "img/general.d1d8118e.svg";